import { createEnumParam } from 'use-query-params';
import { SortOrder } from 'common/types/sort-order';

const SortOrderEnumParam = createEnumParam<SortOrder>(['asc', 'desc']);

export default SortOrderEnumParam;
